import { Type } from 'class-transformer'

export class ClosurePeriodSettingsGetRequest {
  skip!: number
  take!: number

  constructor(skip: number, take:number) {
    this.skip = skip
    this.take = take
  }
}

export class ClosurePeriodSetting {
  closurePeriodSettingId!: string
  ownerNotificationId!: string
  closureStartAt!: string
  closureStartDate!: string
  closureEndAt!: string
  closureEndDate!: string
  memo?: string
}

export class ClosurePeriodSettingsGetResponse {
   @Type(() => ClosurePeriodSetting) closurePeriodSettings: ClosurePeriodSetting[] = []
   closurePeriodSettingCount!: number
}
